/* ============================================================
   JET BELT® Relaunch — Interaktionen (Reveal, Header, PDP)
   Quelle: jetbelt-relaunch/homepage.html + produktseite.html — 1:1.
   Wird von jeder jbr-* Section geladen; Guard verhindert Doppel-Init.
   ============================================================ */
(function () {
  'use strict';

  if (window.__JBR) {
    window.__JBR.scan();
    return;
  }

  var io = null;

  function observer() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    return io;
  }

  /* Header: transparent über dem Hero, solide ab 60px Scroll */
  function updateHeaders() {
    var y = window.scrollY || window.pageYOffset;
    document.querySelectorAll('.jbr-site-header').forEach(function (header) {
      var always = header.getAttribute('data-transparent') === 'false';
      header.classList.toggle('solid', always || y > 60);
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.jbr .reveal:not(.in)').forEach(function (el) {
      observer().observe(el);
    });
    updateHeaders();
  }

  var JBR = window.__JBR = { scan: scan };

  window.addEventListener('scroll', updateHeaders, { passive: true });

  document.addEventListener('click', function (event) {
    /* Mobile-Menü (Burger) */
    var burger = event.target.closest('.jbr-burger');
    if (burger) {
      var header = burger.closest('.jbr-site-header');
      if (header) {
        var open = header.classList.toggle('menu-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('jbr-menu-open', open);
      }
      return;
    }
    if (event.target.closest('.jbr-mobile-nav a')) {
      var openHeader = document.querySelector('.jbr-site-header.menu-open');
      if (openHeader) {
        openHeader.classList.remove('menu-open');
        document.documentElement.classList.remove('jbr-menu-open');
      }
      return;
    }

    /* PDP: Galerie-Thumbnails */
    var thumb = event.target.closest('.jbr .gallery-thumb');
    if (thumb) {
      var gallery = thumb.closest('.gallery');
      if (gallery) {
        gallery.querySelectorAll('.gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        gallery.querySelectorAll('.gallery-main img').forEach(function (i) { i.classList.remove('active'); });
        var target = gallery.querySelector('.gallery-main img[data-img="' + thumb.getAttribute('data-img') + '"]');
        if (target) target.classList.add('active');
      }
      return;
    }

    /* PDP: Mengen-Stepper */
    var qtyBtn = event.target.closest('.jbr .qty-stepper button');
    if (qtyBtn) {
      event.preventDefault();
      var input = qtyBtn.parentElement.querySelector('input');
      if (input) {
        var delta = qtyBtn.getAttribute('data-qty') === '-1' ? -1 : 1;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      }
      return;
    }

    /* PDP: FAQ-Akkordeon */
    var faqQ = event.target.closest('.jbr .faq-q');
    if (faqQ) {
      faqQ.parentElement.classList.toggle('open');
      return;
    }

    /* PDP: Sticky-ATC (mobil) reicht an das Haupt-Produktformular durch */
    var stickyBtn = event.target.closest('[data-jbr-sticky-atc]');
    if (stickyBtn) {
      var form = document.querySelector('.jbr form[data-jbr-product-form]');
      if (form) {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      }
      return;
    }
  });

  /* Ton- und Pause-Schalter fuer stumm startende Videos */
  function jbrVideoOf(btn) {
    var media = btn.closest ? btn.closest('.split-media') : null;
    return media ? media.querySelector('[data-jbr-video]') : null;
  }

  document.addEventListener('click', function (e) {
    var play = e.target.closest && e.target.closest('[data-jbr-play]');
    if (play) {
      var pv = jbrVideoOf(play);
      if (!pv) return;
      var laeuft = !pv.paused;
      if (laeuft) { pv.pause(); pv.setAttribute('data-user-paused', '1'); }
      else { pv.removeAttribute('data-user-paused'); var pr = pv.play(); if (pr && pr.catch) pr.catch(function () {}); }
      play.setAttribute('aria-pressed', laeuft ? 'false' : 'true');
      play.setAttribute('aria-label', laeuft ? 'Video abspielen' : 'Video anhalten');
      var pi = play.querySelector('i');
      if (pi) pi.className = laeuft ? 'fa-solid fa-play' : 'fa-solid fa-pause';
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-jbr-sound]');
    if (!btn) return;
    var video = jbrVideoOf(btn);
    if (!video) return;
    var on = video.muted;
    video.muted = !on;
    if (on && video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Ton ausschalten' : 'Ton einschalten');
    var icon = btn.querySelector('i');
    if (icon) icon.className = on ? 'fa-solid fa-volume-high' : 'fa-solid fa-volume-xmark';
  });

  /* Video haelt sich an, sobald es aus dem Bild scrollt (sonst laeuft es unter dem Systemvideo weiter) */
  function jbrWatchVideos(root) {
    if (!('IntersectionObserver' in window)) return;
    var scope = root || document;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.3) {
          if (!v.hasAttribute('data-user-paused') && v.paused) {
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.3] });
    scope.querySelectorAll('[data-jbr-video]').forEach(function (v) { obs.observe(v); });
  }
  /* YouTube haelt sich ebenfalls an, sobald es aus dem Bild scrollt (sonst doppelter Ton) */
  function jbrWatchYoutube(root) {
    if (!('IntersectionObserver' in window)) return;
    var scope = root || document;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) return;
        var w = en.target.contentWindow;
        if (!w) return;
        try {
          w.postMessage('{"event":"command","func":"pauseVideo","args":[]}', '*');
        } catch (err) {}
      });
    }, { threshold: [0, 0.3] });
    scope.querySelectorAll('[data-jbr-yt]').forEach(function (f) { obs.observe(f); });
  }
  jbrWatchYoutube();
  document.addEventListener('shopify:section:load', function (ev) { jbrWatchYoutube(ev.target); });

  jbrWatchVideos();
  document.addEventListener('shopify:section:load', function (ev) { jbrWatchVideos(ev.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { JBR.scan(); });
  } else {
    JBR.scan();
  }

  /* Theme-Editor: Sections neu initialisieren, wenn sie neu gerendert werden */
  document.addEventListener('shopify:section:load', function (event) {
    JBR.scan(event.target);
  });
})();
